<template>
    <div class="container-action-button">
        <BaseButton @click="onEditArticleKind" buttonText="" title="Modifier la nature">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'pen']" />
            </template>
        </BaseButton>
    </div>
</template>

<script>
    import BaseButton from '../../components/Base/BaseButton.vue';
    import * as Vue from "vue";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

    export default {
        name: 'ListArticleKindsActionButtonsRenderer',
        components: {
            BaseButton: Vue.shallowRef(BaseButton),
            FontAwesomeIcon: Vue.shallowRef(FontAwesomeIcon)
        },
        methods: {
            onEditArticleKind() {
                this.params.context.componentParent.displayEditArticleKindModal(this.params.data);
            }
        }
    }        
</script>